import { Flex, Heading } from '@iziwork/design-system';
import Image from 'next/image';
import React, { FC } from 'react';
import styled from 'styled-components';

import { DownloadApp } from '~/components/DownloadApp';
import { ErrorTemplate } from '~/components/Error/ErrorTemplate';
import { useTranslation } from '~/hooks';

const GreenText = styled.span`
  color: ${({ theme }) => theme.colors.primary.normal};
`;

export const MissionNotFoundError: FC = () => {
  const { t } = useTranslation();
  return (
    <ErrorTemplate title={t('title.404_error')}>
      <Image
        src="/images/outdated.jpg"
        height={312}
        width={312}
        alt=""
        style={{
          maxWidth: '100%',
          height: 'auto',
        }}
      />
      <Flex.Column space="m">
        <Heading variant="heading-1">
          <GreenText>Oops</GreenText>, {t('missions.outdated.oops_text')}
        </Heading>
        <Heading textAlign="center" variant="subtitle">
          {t('missions.outdated.subtitle')}
        </Heading>
        <DownloadApp justifyContent="center" />
      </Flex.Column>
    </ErrorTemplate>
  );
};
